import React, { useState } from 'react';
import { RefreshCw, X, AlertCircle } from 'lucide-react';

const ReprintModal = ({
  isOpen,
  onClose,
  certificate,
  onConfirm,
  loading = false
}) => {
  const [reason, setReason] = useState('');
  const [reprintedBy, setReprintedBy] = useState('Principal / Admin Office');

  if (!isOpen || !certificate) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!reason.trim()) return;
    onConfirm({
      certificateId: certificate.id,
      reason: reason.trim(),
      reprintedBy: reprintedBy.trim()
    });
  };

  const nextCount = (certificate.reprintCount || 0) + 1;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(15, 23, 42, 0.75)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10000,
      padding: '16px',
      boxSizing: 'border-box'
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        maxWidth: '480px',
        width: '100%',
        padding: '24px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2)',
        position: 'relative',
        fontFamily: 'inherit'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: '#64748b'
          }}
        >
          <X size={20} />
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
          <div style={{ backgroundColor: '#fef3c7', padding: '10px', borderRadius: '12px', color: '#d97706', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <RefreshCw size={24} />
          </div>
          <div>
            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: '#1e293b' }}>Log Certificate Reprint</h3>
            <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: '#64748b' }}>Issue official duplicate copy (Reprint #{nextCount})</p>
          </div>
        </div>

        {/* Certificate Quick Info */}
        <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '12px 14px', marginBottom: '16px', fontSize: '12px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
            <span style={{ color: '#64748b' }}>Certificate No:</span>
            <span style={{ fontWeight: '700', color: '#1e3a8a', fontFamily: 'monospace' }}>{certificate.certificateNumber}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
            <span style={{ color: '#64748b' }}>Student Name:</span>
            <span style={{ fontWeight: '700', color: '#0f172a' }}>{certificate.studentName}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ color: '#64748b' }}>Certificate Type:</span>
            <span style={{ color: '#334155' }}>{certificate.certificateType?.replace(/_/g, ' ')}</span>
          </div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div>
            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
              Reason for Reprint <span style={{ color: '#ef4444' }}>*</span>
            </label>
            <textarea
              required
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="e.g. Parent requested duplicate copy due to loss of original document."
              style={{
                width: '100%',
                padding: '9px 12px',
                border: '1px solid #cbd5e1',
                borderRadius: '8px',
                fontSize: '12px',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
              Authorized Staff Name
            </label>
            <input
              type="text"
              value={reprintedBy}
              onChange={(e) => setReprintedBy(e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #cbd5e1',
                borderRadius: '8px',
                fontSize: '12px',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px', backgroundColor: '#fffbeb', border: '1px solid #fef3c7', borderRadius: '8px', fontSize: '11px', color: '#b45309' }}>
            <AlertCircle size={16} color="#d97706" style={{ flexShrink: 0 }} />
            <span>This will generate a watermarked duplicate copy and record the action in the school audit log.</span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '6px' }}>
            <button
              type="button"
              onClick={onClose}
              style={{ padding: '8px 16px', backgroundColor: '#f1f5f9', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: '600', color: '#475569', cursor: 'pointer' }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || !reason.trim()}
              style={{
                padding: '8px 18px',
                backgroundColor: '#d97706',
                border: 'none',
                borderRadius: '8px',
                fontSize: '12px',
                fontWeight: '700',
                color: '#ffffff',
                cursor: loading || !reason.trim() ? 'not-allowed' : 'pointer',
                opacity: loading || !reason.trim() ? 0.6 : 1
              }}
            >
              {loading ? 'Processing...' : `Issue Reprint #${nextCount}`}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReprintModal;
